import React from 'react';

import { TypeOfTranscript } from 'js/src/data/transcript/transcript-types';

export const TranscriptContext = React.createContext({
    typeOfTranscript: TypeOfTranscript.MEDIA_TRANSCRIPT_TAB,
});
